export const hubTokenName = 'Terminus Hub';
